module.exports = __webpack_public_path__ + "img/bicycle.18df978.svg";